import { render } from "./DataSourceSidebar.vue?vue&type=template&id=4da5c0a4&ts=true"
import script from "./DataSourceSidebar.vue?vue&type=script&lang=ts"
export * from "./DataSourceSidebar.vue?vue&type=script&lang=ts"

import "./DataSourceSidebar.vue?vue&type=style&index=0&id=4da5c0a4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__